import type { SwitchItemType } from 'enable-ui';

import { TAB_LABEL } from 'modules/dashboard/styles/tabs';

import { PATH } from 'constants/path';

import { LevelsExercise as levelsExercise } from './enum';

export const getTabs = (): SwitchItemType[] => {
  return [
    {
      children: <></>,
      key: `${PATH.CONTENT}/${PATH.EXERCISES}`,
      label: 'Exercises',
    },
    {
      children: <></>,
      key: `${PATH.CONTENT}/${PATH.LESSONS}`,
      label: 'Lessons',
    },
    {
      children: <></>,
      key: `${PATH.CONTENT}/${PATH.FUNCTIONAL_TESTS}`,
      label: 'Functional tests',
    },
    {
      children: <></>,
      key: `${PATH.CONTENT}/${PATH.ASSESSMENTS}`,
      label: 'Assessments',
    },
    {
      children: <></>,
      key: `${PATH.CONTENT}/${PATH.COURSES}`,
      label: 'Courses',
    },
  ];
};

export const levelTabs = (): SwitchItemType[] => {
  return [
    {
      children: <></>,
      key: levelsExercise.EASY.toString(),
      label: <TAB_LABEL>{`Clients level ${levelsExercise.EASY}`}</TAB_LABEL>,
    },
    {
      children: <></>,
      key: levelsExercise.MEDIUM.toString(),
      label: <TAB_LABEL>{`Clients level ${levelsExercise.MEDIUM}`}</TAB_LABEL>,
    },
    {
      children: <></>,
      key: levelsExercise.HARD.toString(),
      label: <TAB_LABEL>{`Clients level ${levelsExercise.HARD}`}</TAB_LABEL>,
    },
  ];
};
